import * as tslib_1 from "tslib";
import { Model } from '../model';
var LeadClientWhatsappMessage = /** @class */ (function (_super) {
    tslib_1.__extends(LeadClientWhatsappMessage, _super);
    function LeadClientWhatsappMessage(id, poviderType, createDate, leadClientID, messageType, message, senderOrigin, senderDestination, userId, messageContentType, whatsappMessageId, messageStatus, errorDetails, channelId, adName, adGroupId, adId, filename, adPreview, imgSrc, referralData) {
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.poviderType = poviderType;
        _this.createDate = createDate;
        _this.leadClientID = leadClientID;
        _this.messageType = messageType;
        _this.message = message;
        _this.senderOrigin = senderOrigin;
        _this.senderDestination = senderDestination;
        _this.userId = userId;
        _this.messageContentType = messageContentType;
        _this.whatsappMessageId = whatsappMessageId;
        _this.messageStatus = messageStatus;
        _this.errorDetails = errorDetails;
        _this.channelId = channelId;
        _this.adName = adName;
        _this.adGroupId = adGroupId;
        _this.adId = adId;
        _this.filename = filename;
        _this.adPreview = adPreview;
        _this.imgSrc = imgSrc;
        _this.referralData = referralData;
        return _this;
    }
    return LeadClientWhatsappMessage;
}(Model));
export { LeadClientWhatsappMessage };
